if (!customElements.get('viemaa-hero-slider')) {
  class ViemaaHeroSlider extends HTMLElement {
    connectedCallback() {
      if (typeof Swiper === 'undefined') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        return;
      }
      this.init();
    }

    init() {
      if (this.swiper || typeof Swiper === 'undefined') return;

      const slideCount = Number(this.dataset.count) || 0;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const params = {
        speed: reduceMotion ? 0 : 700,
        loop: slideCount > 1,
        allowTouchMove: slideCount > 1,
        navigation: {
          prevEl: this.querySelector('.viemaa-hero-slider__arrow--prev'),
          nextEl: this.querySelector('.viemaa-hero-slider__arrow--next'),
        },
        pagination: {
          el: this.querySelector('.viemaa-hero-slider__pagination'),
          clickable: true,
        },
      };

      if (this.dataset.autoplay === 'true' && slideCount > 1 && !reduceMotion && !(window.Shopify && Shopify.designMode)) {
        params.autoplay = {
          delay: (Number(this.dataset.delay) || 6) * 1000,
          disableOnInteraction: false,
        };
      }

      // Unhide slides 2+ before Swiper measures them, or it sizes them at zero width and can't advance.
      this.classList.add('is-initialized');
      this.swiper = new Swiper(this.querySelector('.viemaa-hero-slider__swiper'), params);
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define('viemaa-hero-slider', ViemaaHeroSlider);

  // Theme editor: jump to a slide when its block is selected.
  document.addEventListener('shopify:block:select', (event) => {
    const slider = event.target.closest('viemaa-hero-slider');
    if (!slider || !slider.swiper) return;
    const index = [...slider.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)')].indexOf(event.target);
    if (index > -1) slider.swiper.slideToLoop(index);
  });
}
